import { useState, useEffect } from 'react';
import {
  Button,
  NoData,
  DatePickerInput,
  OptionsType,
  InputSelect,
} from '@wajeez-web/components/ui';
import dayjs from 'dayjs';
import { PlusIcon } from '@heroicons/react/solid';
import moment from 'moment';
import { Server } from '@wajeez-web/core/api-base';
import { XIcon } from '@heroicons/react/solid';
import { AiOutlineHistory } from 'react-icons/ai';
import { IoCreateOutline } from 'react-icons/io5';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { getLocalTimeFromUTC } from '@wajeez-web/core/utils';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import {
  useCustomerSelector,
  CustomerCareActions,
} from '@wajeez-web/stores/customers';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import { enumMapper } from '@wajeez-web/core/utils';

const purchaseSourceOptionList = [
  {
    label: 'Internal',
    value: Server.PurchaseSource.INTERNAL,
  },
  {
    label: 'Offline',
    value: Server.PurchaseSource.OFFLINE,
  },
  {
    label: 'Reward',
    value: Server.PurchaseSource.REWARD,
  },
  {
    label: 'Sales',
    value: Server.PurchaseSource.SALES,
  },
];

const UserSubscriptionElementForm = ({
  data,
  getData,
}: {
  data: Server.UserDetailsOutput;
  getData: () => void;
}) => {
  const { subscriptionHistory, subscriptionStatus, products } =
    useCustomerSelector((s) => s.customerCare);
  const dispatch = useCommonDispatch();
  const [addsubsicription, setAddSubsicription] = useState(false);

  const [selectedProductBody, setSeectedProductBody] = useState<{
    productId: number;
    startingFrom: string;
  }>({ productId: -1, startingFrom: moment(new Date()).toISOString() });
  const [selectedPurchaseSource, setSelectedpurchesSource] =
    useState<Server.PurchaseSource | null>(null);

  useEffect(() => {
    data.id && getSubscroptions();
  }, [data.id]);

  const getSubscroptions = () => {
    data.id &&
      dispatch(CustomerCareActions.getSubsicriptionHistoryAsync(data.id));
  };

  useEffect(() => {
    if (selectedPurchaseSource !== null) {
      dispatch(
        CustomerCareActions.getProductByPurchaseSourceAndProductTypeAsync({
          PurchaseSource: Number(selectedPurchaseSource),
        })
      );
    }
  }, [selectedPurchaseSource]);
  return (
    <div className=" space-y-2 mt-2">
      <div className="flex justify-between border-b py-4">
        <div className="text-lg font-bold">
          <ReturnTranslatedText
            origintext="Subscription"
            text={`general.${'Subscription'}`}
          />
        </div>
        <div>
          <Button
            title={'Add'}
            Icon={PlusIcon}
            onClick={() => setAddSubsicription(true)}
          />
        </div>
      </div>
      <div className="py-4">
        <div className="space-y-4">
          {addsubsicription && (
            <div className=" space-y-2 py-4 border-b">
              <div className="flex space-s-2">
                <div>
                  <IoCreateOutline className="h-5 w-5" />
                </div>
                <div className=" text-base text-center">
                  <ReturnTranslatedText
                    origintext="Create Subscription"
                    text={`general.${'Create Subscription'}`}
                  />
                </div>
                <div
                  onClick={() => setAddSubsicription(false)}
                  className=" text-right justify-end cursor-pointer "
                >
                  <XIcon className="h-5 w-5 text-red-500 hover:text-red-300 " />
                </div>
              </div>
              <div className=" rounded-md shadow-md p-2 space-y-2">
                <InputSelect
                  label={'Purchase Source'}
                  value={
                    selectedPurchaseSource
                      ? purchaseSourceOptionList.find(
                          (ele) => ele.value === selectedPurchaseSource
                        )
                      : undefined
                  }
                  name="PurchaseSource"
                  onChange={(name, value: any) =>
                    setSelectedpurchesSource(value.value)
                  }
                  options={purchaseSourceOptionList}
                />
                <InputSelect
                  label={'Product'}
                  value={
                    selectedProductBody.productId
                      ? products
                          .map((ele: any) => ({
                            value: ele.id,
                            label: `${ele.name} (${ele.purchaseProviderKey})`,
                          }))
                          .find(
                            (ele) =>
                              ele['value'] === selectedProductBody.productId
                          )
                      : undefined
                  }
                  name="ProductId"
                  onChange={(name, value: any) =>
                    setSeectedProductBody({
                      ...selectedProductBody,
                      productId: value.value,
                    })
                  }
                  options={products.map((ele: any) => ({
                    value: ele.id,
                    label: `${ele.name} (${ele.purchaseProviderKey})`,
                  }))}
                />
                <DatePickerInput
                  name="startingFrom"
                  label="Starting From"
                  onChange={(name, value) =>
                    setSeectedProductBody({
                      ...selectedProductBody,
                      startingFrom: value,
                    })
                  }
                  value={selectedProductBody.startingFrom}
                />
                <div className="flex justify-end pt-2">
                  <Button
                    title="Save"
                    onClick={() => {
                      data.id &&
                        dispatch(
                          CustomerCareActions.addCustomerProductAsync({
                            customerId: data.id,
                            productId: selectedProductBody.productId,
                            startingFrom: selectedProductBody.startingFrom,
                          })
                        ).then(() => {
                          getSubscroptions();
                          setAddSubsicription(false);
                          getData();
                        });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="flex space-s-2">
            <div>
              <AiOutlineHistory className="h-5 w-5" />
            </div>
            <div className=" text-base text-center">
              <ReturnTranslatedText
                origintext="Subscription History"
                text={`general.${'Subscription History'}`}
              />
            </div>
          </div>
          <div className=" divide-y overflow-clip ">
            <div className="grid grid-cols-4 items-center gap-x-2 gap-y-2 py-2 text-center">
              <div className="px-1">
                <ReturnTranslatedText
                  origintext="Purchase Type"
                  text={`tables.columnTitles.${'Purchase Type'}`}
                />
              </div>
              <div className="px-1">
                <ReturnTranslatedText
                  origintext="Purchase Source"
                  text={`tables.columnTitles.${'Purchase Source'}`}
                />
              </div>
              <div className="px-1">
                <ReturnTranslatedText
                  origintext="Start Date"
                  text={`tables.columnTitles.${'Start Date'}`}
                />
              </div>
              <div className="px-1">
                <ReturnTranslatedText
                  origintext="Expiration Date"
                  text={`tables.columnTitles.${'Expiration Date'}`}
                />
              </div>
            </div>
            {subscriptionHistory.length ? (
              subscriptionHistory.map((item, i) => (
                <div className="flex justify-center items-center py-2 divide-s text-center break-words tex-xs">
                  <div className="w-1/4 px-2 py-2">
                    {item.purchaseType &&
                      Server.PurchaseType[item.purchaseType]}
                  </div>
                  <div className="w-1/4 px-2 py-2">
                    {item.purchaseSource &&
                      Server.PurchaseSource[item.purchaseSource]}
                  </div>
                  <div className="w-1/4 px-2 py-2">
                    {getLocalTimeFromUTC(item.startDate || '')}
                  </div>
                  <div className="w-1/4 px-2 py-2 flex space-s-2 align-middle items-center justify-center">
                    <div>
                      {(item.expirationDate &&
                        getLocalTimeFromUTC(item.expirationDate)) ||
                        '-'}
                    </div>
                    {item.expirationDate &&
                      dayjs(item.expirationDate) > dayjs(new Date()) && (
                        <Button
                          type="text"
                          color="red-500"
                          title={'Expire'}
                          onClick={() => {
                            dispatch(
                              CustomerCareActions.expireCustomerProductAsync({
                                customerProductId: item.customerProductId,
                              })
                            ).then(() => {
                              getSubscroptions();
                              dispatch(
                                CommonActions.setAlert({
                                  type: AlertType.SUCCESS,
                                  messages: [
                                    {
                                      message:
                                        'Subscription has been expired successfully',
                                      code: 200,
                                      field: null,
                                    },
                                  ],
                                })
                              );
                            });
                          }}
                        />
                      )}
                  </div>
                </div>
              ))
            ) : (
              <NoData />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSubscriptionElementForm;
